// 28 Indian states
export const INDIAN_STATES = [
    { code: "AN", name: "Andhra Pradesh" },
    { code: "AR", name: "Arunachal Pradesh" },
    { code: "AS", name: "Assam" },
    { code: "BR", name: "Bihar" },
    { code: "CG", name: "Chhattisgarh" },
    { code: "GA", name: "Goa" },
    { code: "GJ", name: "Gujarat" },
    { code: "HR", name: "Haryana" },
    { code: "HP", name: "Himachal Pradesh" },
    { code: "JH", name: "Jharkhand" },
    { code: "KA", name: "Karnataka" },
    { code: "KL", name: "Kerala" },
    { code: "MP", name: "Madhya Pradesh" },
    { code: "MH", name: "Maharashtra" },
    { code: "MN", name: "Manipur" },
    { code: "ML", name: "Meghalaya" },
    { code: "MZ", name: "Mizoram" },
    { code: "NL", name: "Nagaland" },
    { code: "OD", name: "Odisha" },
    { code: "PB", name: "Punjab" },
    { code: "RJ", name: "Rajasthan" },
    { code: "SK", name: "Sikkim" },
    { code: "TN", name: "Tamil Nadu" },
    { code: "TG", name: "Telangana" },
    { code: "TR", name: "Tripura" },
    { code: "UP", name: "Uttar Pradesh" },
    { code: "UK", name: "Uttarakhand" },
    { code: "WB", name: "West Bengal" },
    // 8 Union Territories
    { code: "AN-UT", name: "Andaman and Nicobar Islands" },
    { code: "CH-UT", name: "Chandigarh" },
    { code: "DH-UT", name: "Dadra and Nagar Haveli and Daman and Diu" },
    { code: "DL-UT", name: "Delhi" },
    { code: "JK-UT", name: "Jammu and Kashmir" },
    { code: "LD-UT", name: "Ladakh" },
    { code: "LK-UT", name: "Lakshadweep" },
    { code: "PY-UT", name: "Puducherry" },
];
export const BLOOD_GROUPS = ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-"];
// Salutations for the patient name field. Order is the display order.
export const SALUTATIONS = [
    "Mr.",
    "Ms.",
    "Mrs.",
    "Master.",
    "Selvi.",
    "Dr.",
    "Baby",
    "Baby Of",
];
export const SPECIALTIES = [
    "General Medicine",
    "Cardiology",
    "Neurology",
    "Pediatrics",
    "Orthopedics",
    "Dermatology",
    "Psychiatry",
    "Obstetrics & Gynecology",
    "ENT",
    "Ophthalmology",
    "General Surgery",
    "Internal Medicine",
    "Endocrinology",
    "Nephrology",
    "Pulmonology",
    "Gastroenterology",
    "Oncology",
    "Urology",
];
// Common Indian prescription frequency abbreviations.
export const FREQUENCIES = [
    { code: "BD", label: "BD — Twice daily" },
    { code: "TDS", label: "TDS — Three times daily" },
    { code: "HS", label: "HS — At bedtime" },
    { code: "OD", label: "OD — Once daily" },
    { code: "QID", label: "QID — Four times daily" },
    { code: "PRN", label: "PRN — As needed" },
    { code: "SOS", label: "SOS — If required (once)" },
    { code: "STAT", label: "STAT — Immediately" },
];
export const INVESTIGATION_CATEGORIES = [
    "Hematology",
    "Biochemistry",
    "Microbiology",
    "Radiology",
    "Cardiology",
    "Neurology",
    "Endocrinology",
    "Other",
];
export const FORMULATIONS = [
    "Tablet",
    "Capsule",
    "Syrup",
    "Injection",
    "Drops",
    "Ointment",
    "Powder",
    "Inhaler",
];
export const GENDERS = ["Male", "Female", "Other"];
// v1 slot keys (the seeded slot_defs keys — also the legacy enum labels).
// Slot is now a free string (0027): N-slot keys typecheck against it.
// Keep SLOTS as the v1 key list for UI iteration.
export const SLOTS = ["Morning", "Evening"];
export const APPOINTMENT_STATUSES = [
    "Pending",
    "Booked",
    "CheckedIn",
    "Completed",
    "Cancelled",
    "NoShow",
];
export const INVOICE_STATUSES = ["Unpaid", "Partial", "Paid"];
// Letter types — the UI label differs from the stored enum value.
export const LETTER_TYPES = ["Incoming", "Outgoing"];
export const LETTER_TYPE_LABELS = {
    Incoming: "Referral Reply",
    Outgoing: "Referral To",
};
export const RECIPIENT_TYPES = ["whomsoever", "specific"];
// Discharge summary document headings — the stored enum value IS the PDF
// heading text (rendered uppercase, centered, maroon, underlined).
export const DISCHARGE_HEADINGS = [
    "Discharge Summary",
    "Discharge At Request",
    "Discharge Against Medical Advice",
];
// Editor sections that support insertable templates (mirrors the
// discharge_template_section DB enum).
export const DISCHARGE_TEMPLATE_SECTIONS = ["History", "Examination"];
//# sourceMappingURL=constants.js.map